<template>
  <div class="table-container">
    <table class="modern-data-table">
      <thead>
        <slot name="table-header"></slot>
      </thead>
      <tbody>
        <slot name="table-body"></slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableComponent",
};
</script>

